




























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';

import { mapActions } from 'vuex';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';
import Tab from '@/components/Tab/Tab.vue';
import Button from '@/components/Button.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import { ActionTypes } from '@/store/disbursementManagement';
import Accordion from '@/components/Accordion.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import TagInput from '@/components/TagInput.vue';
import ReportTable from './MerchantChargeTable.vue';
import BalanceJumbotron from '../components/BalanceJumbotron.vue';

@Component({
  components: {
    LayoutTitle,
    Button,
    LayoutContent,
    Tab,
    SummaryBox,
    ReportTable,
    Accordion,
    SearchField,
    SearchRow,
    SearchIcon,
    ExportIcon,
    DatePicker,
    TagInput,
    BalanceJumbotron,
  },

  methods: mapActions({ getBalance: ActionTypes.GET_DISBURSEMENT_REVENUE }),
})
export default class Report extends Vue {
  getBalance!: () => void;
  loadingSummaryTraffic = false;
  summaryTraffic = 0;
  summaryAmount = 0;
  searchOpen = false;
  api_usage: SelectItem[] = []
  merchant_code: SelectItem[] = []
  revenue: SelectItem[] = []
  service_fee: SelectItem[] = []
  gross_fee: SelectItem[] = []
  // date: { label: string; value: string }[] = []
  summaryStatusOptions = [
    {
      label: 'All Status',
      value: 'all',
    },
    {
      label: 'Success',
      value: '00',
    },
    {
      label: 'Declined',
      value: '01',
    },
  ];

  currentChannel = {
    title: 'Merchant Charge',
    code: 'merchantCharge',
    path: 'merchantCharge',
  }

  transactionDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  $refs!: {
    report: ReportTable;
  }

  date: DateRange = {
    startDate: null,
    endDate: null,
  }

  mounted() {
    this.getBalance();
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getTransaction(page: number) {
    const params = {
      date: this.date,
      // eslint-disable-next-line @typescript-eslint/camelcase
      merchant_code: this.merchant_code,
      // eslint-disable-next-line @typescript-eslint/camelcase
      api_usage: this.api_usage,
      // eslint-disable-next-line @typescript-eslint/camelcase
      revenue: this.revenue,
      // eslint-disable-next-line @typescript-eslint/camelcase
      service_fee: this.service_fee,
      // eslint-disable-next-line @typescript-eslint/camelcase
      gross_fee: this.gross_fee,
      // channel: this.currentChannel,
      // transactionDate: this.transactionDate,
    };

    await this.$refs.report.getTransaction(params, page);
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.td === 'string') {
      const dates = params.td.split(',');
      this.date = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    }

    if (typeof params.mc === 'string') {
      const ids = params.mc.split(',');
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.merchant_code = ids.map((e) => ({ key: '', value: e }));
    } else {
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.merchant_code = [];
    }

    if (typeof params.au === 'string') {
      const ids = params.au.split(',');
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.api_usage = ids.map((e) => ({ key: '', value: e }));
    } else {
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.api_usage = [];
    }

    if (typeof params.rv === 'string') {
      const ids = params.rv.split(',');
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.revenue = ids.map((e) => ({ key: '', value: e }));
    } else {
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.revenue = [];
    }

    if (typeof params.sf === 'string') {
      const ids = params.sf.split(',');
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.service_fee = ids.map((e) => ({ key: '', value: e }));
    } else {
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.service_fee = [];
    }

    if (typeof params.gf === 'string') {
      const ids = params.gf.split(',');
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.gross_fee = ids.map((e) => ({ key: '', value: e }));
    } else {
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.gross_fee = [];
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getTransaction(page);
  }

  search() {
    const td = this.transactionDate.startDate === null || this.transactionDate.endDate === null ? undefined : {
      start: dayjs(this.transactionDate.startDate).format('YYYY-MM-DD'),
      end: dayjs(this.transactionDate.endDate).format('YYYY-MM-DD'),
    };

    this.$router.push({
      query: {
        td: td && `${td.start},${td.end}`,
        mc: this.merchant_code.length === 0 ? undefined : this.merchant_code.map((e) => e.value).join(','),
        au: this.api_usage.length === 0 ? undefined : this.api_usage.map((e) => e.value).join(','),
        rv: this.revenue.length === 0 ? undefined : this.revenue.map((e) => e.value).join(','),
        sf: this.service_fee.length === 0 ? undefined : this.service_fee.map((e) => e.value).join(','),
        gf: this.gross_fee.length === 0 ? undefined : this.gross_fee.map((e) => e.value).join(','),
      },
    });
  }

  cancel() {
    this.transactionDate = {
      startDate: null,
      endDate: null,
    };
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.merchant_code = [];
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.api_usage = [];
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.revenue = [];
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.service_fee = [];
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }
}
